import { formatPercentage } from '@helpers/utils/numbers/numbers';
import { DateCell } from '@terminal/widgets/earnings/components/date-cell/DateCell';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './TopCompetitors.module.scss';
import { CompetitorEarningsSnapshot } from './utils';

export const Placeholder = () => <span className={styles.placeholder}>-</span>;

export const SignedPercentage = ({ value }: { value?: number }) => {
  if (value === undefined) {
    return <Placeholder />;
  }

  return (
    <span
      className={clsx({
        [styles.bullish]: value > 0,
        [styles.bearish]: value < 0,
      })}
    >
      {formatPercentage(value, {
        useOriginalValue: true,
        suffix: '%',
        addPlus: true,
      })}
    </span>
  );
};

export const ReportingDateCell = ({
  reportingDate,
  hasReported,
}: Pick<CompetitorEarningsSnapshot, 'reportingDate' | 'hasReported'>) => {
  const { t } = useTranslation(['earnings']);

  if (!reportingDate) {
    return (
      <span className={styles.placeholder}>
        {t('earnings:peerComparison.topCompetitors.notAnnounced')}
      </span>
    );
  }

  return (
    <DateCell
      date={new Date(reportingDate)}
      displayIcon={hasReported === false}
      timeFormat="h:mmaaa zz"
    />
  );
};
